import PaymentLinksList from "@/pages/PaymentLinksList";
import Modal from "@/components/Modal";

/**
 * Admin-side wrapper: opens as a modal from AdminPartners → manages
 * payment links for one specific partner.
 */
export default function PaymentLinksDrawer({ partner, onClose }) {
    return (
        <Modal testId="payment-links-modal" onClose={onClose}
               title={`Payment links · ${partner.business_name}`} size="xl">
            <PaymentLinksList scope="admin"
                              partnerId={partner.partner_id}
                              partnerBusinessName={partner.business_name} />
        </Modal>
    );
}
